import React from 'react';
import { SlidersHorizontal } from '@phosphor-icons/react';

export type PreContractAiDesignConfigButtonProps = {
    onClick: () => void;
    disabled?: boolean;
};

/** Opens the full solar layout popup for module/config editing. */
export const PreContractAiDesignConfigButton: React.FC<PreContractAiDesignConfigButtonProps> = ({
    onClick,
    disabled = false,
}) => (
    <button
        type="button"
        className="pci-ai-designs__config-btn"
        disabled={disabled}
        onClick={onClick}
    >
        <SlidersHorizontal size={15} weight="bold" aria-hidden />
        AI Design config
    </button>
);

export default PreContractAiDesignConfigButton;
